import { Image as MantineImage, ImageProps } from '@mantine/core';

export type IImageProps = ImageProps;

/** @registry Design-layer pass-through over Mantine Image; import this instead of @mantine/core Image outside src/design. Extend here when Image needs house behavior. */
export const Image = MantineImage;
